
const routes = [
  {
    path: "/wizards/marketing",
    component: () => import(/* webpackChunkName: "MarketingWizard" */ "./MarketingWizard/MarketingWizard")
  },
  {
    path: "/wizards/payment",
    component: () => import(/* webpackChunkName: "PaymentWizard" */ "./PaymentWizard/PaymentWizard")
  },
  {
    path: "/wizards/app-market",
    component: () => import(/* webpackChunkName: "AppMarketWizard", webpackPrefetch: true */ "./AppMarketWizard/AppMarketWizard"),
    children: [
      {
        path: ":codeName",
        name: "appInfoPage",
        component: () => import(/* webpackChunkName: "AppMarketWizard", webpackPrefetch: true */ "./AppMarketWizard/AppMarketWizard")
      }
    ]
  },
  {
    path: "/wizards/xpert",
    component: () => import(/* webpackChunkName: "XpertWizard" */ "./XpertWizard/XpertWizard")
  },
  {
    path: "/app-dialog",
    component: () => import(/* webpackChunkName: "CoreWizardDialog" */ "./CoreWizardDialog/CoreWizardDialog")
  },
  {
    path: "/wizards/payment-iframe",
    component: () => import(/* webpackChunkName: "PaymentIframeWizard" */ "./IframeUrl/IframeUrlPage")
  },

];
export default routes;
